import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Button from '../Button/Button'

function ClientSummary({ clientSummary }) {
    const {
        backgroundImage,
        caseStudyDetails,
        clientDetails,
        description,
        documentLink,
        summaryTitle,
        title
    } = clientSummary || {}
    return (
        <section>
            <div className="container grid lg:grid-cols-[2fr_1.5fr] xl:grid-cols-[2fr_1fr] gap-x-7">
                <div className="relative bg-dark_purple isolate text-white py-8 px-5 lg:pb-12 lg:px-10">
                    {backgroundImage?.localFile ? (
                        <GatsbyImage
                            objectFit="cover"
                            image={getImage(
                                backgroundImage?.localFile?.childImageSharp
                            )}
                            alt={backgroundImage?.altText}
                            className={'!absolute inset-0 !w-full h-full -z-10'}
                        />
                    ):(
                        <img
                            src={
                                backgroundImage?.sourceUrl
                            }
                            alt={backgroundImage?.altText}
                            className={'!absolute inset-0 !w-full h-full -z-10 object-cover'}
                        />
                    )}

                    <div className="text-xl leading-6 ">
                        {title && <h2 className="h3 mb-4">{title}</h2>}
                        {description && (
                            <p className="mb-12 text-xl leading-6 xl:w-[86%]">
                                {description}
                            </p>
                        )}

                        {clientDetails && (
                            <ul className="space-y-[18px]">
                                {clientDetails?.map((detail, index) => {
                                    const { title, description } = detail || {}

                                    return (
                                        <li className="" key={index}>
                                            {title && (
                                                <strong className="inline-block mr-1.5">
                                                    {title}
                                                </strong>
                                            )}
                                            {description && (
                                                <span>{description}</span>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="border p-5 lg:p-8 border-solid border-[#d9d9d9]">
                    {summaryTitle && (
                        <h2 className="h4 text-vivid_raspberry mb-8">
                            {summaryTitle}
                        </h2>
                    )}

                    {caseStudyDetails && (
                        <ul className="space-y-3 mb-10 text-lg list-disc pl-7">
                            {caseStudyDetails?.map(({ detail }, index) => {
                                return <li key={index}>{detail}</li>
                            })}
                        </ul>
                    )}

                    <Button
                        buttonLink={{
                            url: documentLink,
                            target: true
                        }}
                        download
                        className="bg-vivid_raspberry lg:py-3 text-white border-vivid_raspberry hover:bg-white hover:!text-vivid_raspberry hover:border-vivid_raspberry"
                    >
                        <span className="inline-flex gap-x-[10px] items-center">
                            <span>Download</span>
                            <DownloadIcon />
                        </span>
                    </Button>
                </div>
            </div>
        </section>
    )
}

const DownloadIcon = () => {
    return (
        <svg
            width={25}
            height={24}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.5 17V19C4.5 19.5304 4.71071 20.0391 5.08579 20.4142C5.46086 20.7893 5.96957 21 6.5 21H18.5C19.0304 21 19.5391 20.7893 19.9142 20.4142C20.2893 20.0391 20.5 19.5304 20.5 19V17M7.5 11L12.5 16M12.5 16L17.5 11M12.5 16V4"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ClientSummary
